"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInteractionReset = isInteractionReset;
exports.createLocalInteractionRecord = createLocalInteractionRecord;
exports.createInteractionRecord = createInteractionRecord;
exports.initInteractionRecord = initInteractionRecord;
exports.toEngagementRecord = toEngagementRecord;
exports.restoreLocalInteraction = restoreLocalInteraction;
exports.saveLocalInteraction = saveLocalInteraction;

var _immutable = require("immutable");

var _EngagementRecord = _interopRequireDefault(require("customer-data-objects/engagement/EngagementRecord"));

var _InteractionRecord = _interopRequireDefault(require("customer-data-objects/interaction/InteractionRecord"));

function isInteractionReset(oldInteractionRecord, newInteractionRecord) {
  var metadataAttr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'body';
  return oldInteractionRecord !== newInteractionRecord && !newInteractionRecord.metadata.get(metadataAttr);
}

function createLocalInteractionRecord(richTextEditorResults) {
  return new _InteractionRecord.default({
    richTextEditorResults: richTextEditorResults
  });
}

function createInteractionRecord(richTextEditorResults) {
  return new _InteractionRecord.default((0, _immutable.fromJS)({
    metadata: {
      body: richTextEditorResults.html(),
      plainText: richTextEditorResults.plainText()
    },
    associations: {
      ownerIds: (0, _immutable.Set)(richTextEditorResults.atMentions())
    }
  }));
}

function initInteractionRecord(interactionRecord, engagementType, ownerId, teamId) {
  if (engagementType) {
    interactionRecord = interactionRecord.setEngagementType(engagementType);
  }

  var owner = interactionRecord.getIn(['engagement', 'ownerId'], ownerId);
  interactionRecord = interactionRecord.setOwnerId(owner);
  var team = interactionRecord.getIn(['engagement', 'teamId'], teamId);

  if (team) {
    interactionRecord = interactionRecord.setTeamId(team);
  }

  return interactionRecord;
}

function toEngagementRecord(interactionRecord) {
  return (0, _EngagementRecord.default)(interactionRecord.toMap());
}

function restoreLocalInteraction(localInteraction, localTransforms) {
  if (!localInteraction.isRestored()) {
    return null;
  }

  var interaction = new _InteractionRecord.default();
  localTransforms.forEach(function (transform) {
    interaction = transform.toInteractionRecord(localInteraction, interaction);
  });
  return {
    interaction: interaction,
    attachments: localInteraction.get('attachments')
  };
}

function saveLocalInteraction(localInteraction, interactionRecord, localTransforms) {
  if (interactionRecord != null) {
    localTransforms.forEach(function (transform) {
      return transform.toLocalInteraction(interactionRecord, localInteraction);
    });
  }

  return localInteraction.save();
}